import { Component, OnInit } from "@angular/core";
import { Validators, FormGroup, FormControl } from "@angular/forms";
import { AuthenticateModel, Authorise } from "../../models/authenticateModel";
import { LoginService } from "../../services/login.service";
import { SessionService } from "../../services/session.service";
import { UserService } from "../../services/user.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  submitting: boolean = false;
  returnUrl: string;
  username: string = "";
  password: string = "";

  constructor(
    private loginService: LoginService,
    private session: SessionService
  ) {}

  ngOnInit() {}

  myLoginFunc(event) {
    event.preventDefault();
    this.submitting = true;
    var authorise = new Authorise();
    // authorise.password = "1234";
    // authorise.username = "ib001";
    authorise.password = this.password;
    authorise.username = this.username;
    authorise.deviceid = "1";
    var authenticateModel = new AuthenticateModel();
    authenticateModel.authorise = authorise;
    //console.log("authenticateModel")
    //console.log(authenticateModel)
    this.loginService.authenticate(authenticateModel);

    () => (this.submitting = false);
  }

  // AddNumber() {
  //   console.log("clicked Forget Password");

  // }
}
